module.exports = __webpack_public_path__ + "images/volkerstevin_smalle767da4f42fa62dbce217d1b76ef7e87.png";